<template>
	<div class="hello" style="width: 1440px; margin: 0 auto;">
		<div class="__foot">
			<div class="top">
				<div class="page-center-content">
					<div>{{info.name}}</div>
					<div><a class="bei" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备:{{info.icp}}</a></div>
					<div>公司地址：{{info.address}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		imgurl,getAction
	} from "@/api/manage";
	
	export default {
			name: 'FooterPart',
			props: {
				msg: String
			},
			data() {
				return {
					imgurl: imgurl,
					info: {},
	
				}
			},
			mounted(e) {
				let that = this;
				that.getinfo();
	
			},
			
			methods: {
				
				getinfo(){
					let that = this;
					let param = {};
					getAction("viwo/homePage/getMainInfo", param).then(res => {
						if (res.success && res.result) {
							that.info = res.result;
							console.log("公司信息res===",res)
						}
					})
				},
				
			}
		}
	</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.__foot {
	    font-size: 14px;
		.top {
			
		    background-color: #2D2D2D;
		    color: #fff;
			.page-center-content {
				
			    display: flex;
				flex-direction: column;
			    align-items: center;
			    justify-content: center;
			    height: 186px;
				// font-weight: bold;
				line-height: 29px;
				color: rgb(255,255,255);
				font-size: 28px;
			}
			.bei {
				color: rgb(255,255,255);
				font-size: 28px;
			}
		}

	}
	.page-center-content {
	    width: 600px;
	    margin: 0 auto;
	}
</style>